import logo from "./logo.svg";
import "./App.css";

import Profile from "./pages/Profile";

function App() {
  return (
    <div className="App">
      <Profile />
    </div>
  );
}

export default App;
